import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { Area } from '../../DataStructures/Area/Area';

@Injectable()
export class MapquestService {

  private key4 = "r2AKgP8FoGLBVSBm1f0LfPYj1IZHiR6o";
  private key3 = "sVrGWTlkRP0iVXgBQbcmkjU0QsfwrN0m";
  private key2 = "xU48PDTKvAUBHkvzUVbLqcWiKxr13rIW";
  private key1 = "WDOFqmzI2MrvGHxEak5D93MGkCaMTBfk";
 
  private apiKey = "";

  private url = "https://www.mapquestapi.com/directions/v2/route?key=";
  private optimizedRoute = "https://www.mapquestapi.com/directions/v2/optimizedroute?key=";
  private route = "https://www.mapquestapi.com/directions/v2/route?key="
  private routeMatrix = "https://www.mapquestapi.com/directions/v2/routematrix?key=";

  constructor(private http:Http) {

    /*this.getSelectedApiKey().then(( res:any) =>{
      if(res.status){
        this.apiKey = res.data.value;
        this.url = this.url+this.apiKey;
        this.optimizedRoute = this.optimizedRoute + this.apiKey;
        this.route = this.route + this.apiKey;
        this.routeMatrix = this.routeMatrix + this.apiKey;

      }else{
        alert("Fatal Error: Could Not get Mapping API Key: " + res.message);
      }
    }).catch(e =>{

      alert("Fatal Error: Could Not get Mapping API Key: " + e);
    })*/
  }

  clusterPoints(areas:Array<Area>){

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CLUSTER_POINTS;
    return this.http.post(url,areas).toPromise().then(res => res.json());
  }

  getDirections(request) : Promise<string>{

    return this.http.post(this.url,JSON.stringify(request)).toPromise()
    .then( res => res.json());
  }

  distanceMatrix(request):Promise<string>{
    
    return this.http.post(this.routeMatrix,JSON.stringify(request)).toPromise().then(res => res.json());
  }

  private getSelectedApiKey(): Promise<string> {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_SELECTED_SETTING + "/maquestkey"; 
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getOptimizedRoute(request) : Promise<string>{

    return this.http.post(this.optimizedRoute,JSON.stringify(request)).toPromise()
    .then( res => res.json());
  }

  getRoute(request): Promise<string>{
    return this.http.post(this.route,JSON.stringify(request)).toPromise()
    .then( res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/map-quest/mapquest.service.ts